import React, { useEffect, useState } from "react";
import { customer_attributes } from "../../services/dwhservices";
import { employeedetails, ticketViewService } from "../../services/merpservices";
import { gaEvent } from "../../utils/GoogleAnalytics/gatracking";
import { getColors } from "./ColorCoding";
import ServiceDetails from "../NachHistory/ServiceDetails";
import { useGlobalContext } from "../../SearchBar/SearchBar";
import PopupTable from "../TablePopUp/PopupTable";
import { useGlobalAppContext } from "../../context/Context";

const CustomerEngagement = ({glid, empid, ak, companyname, setTopProductsList}) => {
  const [empDetails, setEmpDetails] = useState([]);
  const [ticketAgeing5Days, setTicketAgeing5Days] = useState(false);
  const {paidFree, setDisplayIrateFlag} = useGlobalContext();
  const {showPastServices, handleShowPastServices, pastServiceData} = useGlobalAppContext();

  const [data, setData] = useState([
    { id: 1, leftTitle: "BL Active", leftValue: "0 D", rightTitle: "Products ", rightValue: 0},
    { id: 2, leftTitle: "BL NI", leftValue:  0, rightTitle: "Categories", rightValue: 0},
    { id: 3, leftTitle: "Lead Mgr. Active", leftValue: 0, rightTitle: "A Rank", rightValue: 0},
    { id: 4, leftTitle: "Calls (Success%)", leftValue: "0(0%)", rightTitle: "D Rank", rightValue: 0 },
    { id: 5, leftTitle: "No.s Mapped", leftValue: 0, rightTitle: "Catalog Score", rightValue: "0%" },
    { id: 6, leftTitle: "Enquiry", leftValue: 0, rightTitle: "Tickets WIP/Closed", rightValue: 0/0 },
    { id: 7, leftTitle: "Avg. Rating", leftValue: "NA",   rightTitle: "Negative Feedback", rightValue: 0 },
  ]);

  const customerAtrributes = async (glid) => {
    try {
      var res = await customer_attributes(glid);
      const ticketCounts  =  await wipCloseTicketCount();
      const {wipTicketCount, closedTicketCount} = ticketCounts;
      res = res.data;
      if(res.status_code === 200){
        res = JSON.parse(res.response)
        if(res.cust_attr.length > 0 ){
          const data = res.cust_attr[0];
          const customer_Data = [
            { id: 1, leftTitle: "BL Active", leftValue: `${data?.bl_dau_1m} D`, rightTitle: "Products", rightValue: data?.live_prd_cnt},
            { id: 2, leftTitle: "BL NI", leftValue:  data?.bl_rej_30d, rightTitle: "Categories", rightValue: data?.mcat_count},
            { id: 3, leftTitle: "Lead Mgr. Active", leftValue: data?.lms_lm, rightTitle: "A Rank", rightValue: data?.a_rank_mcats},
            { id: 4, leftTitle: "Calls (Success%)", leftValue: `${data?.pns_total_30d}(${data?.pns_per_30d}%)`, rightTitle: "D Rank", rightValue: data?.d_ranked_products },
            { id: 5, leftTitle: "No.s Mapped", leftValue: data?.count_of_number_mapped, rightTitle: "Catalog Score", rightValue: `${data.cqs} %` },
            { id: 6, leftTitle: "Enquiry", leftValue: data?.enq, rightTitle: "Tickets WIP/Closed", rightValue: `${wipTicketCount}/${closedTicketCount}` },
            { id: 7, leftTitle: "Avg. Rating", leftValue: (data?.avg_ratings === 0 || data?.avg_ratings == null) ? "NA" : data?.avg_ratings.toFixed(1) ,   rightTitle: "Negative Feedback", rightValue: data?.fdbk_nt_satisfied },
          ];
          // setTopProductsList(data?.top_10_mcat);
          setData(customer_Data);
        }
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  function parseDateString(dateStr) {
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const [day, month, year] = dateStr.split('-');

    const dayInt = parseInt(day);
    const monthInt = monthNames.indexOf(month.toUpperCase());
    const yearInt = parseInt(year) + 2000; // Assuming '24' means 2024

    return new Date(yearInt, monthInt, dayInt);
  }

  function isDateOlderThan5Days(dateStr) {
    const inputDate = parseDateString(dateStr);
    const currentDate = new Date();
    
    const diffTime = currentDate - inputDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24); // Convert milliseconds to days
    
    return diffDays > 5;
  }
  
  const wipCloseTicketCount = async () => {
    let wipTicketCount = 0;
    let closedTicketCount = 0;
    const res = await ticketViewService(empid, ak, glid, '');
    const ticketsdata = res?.data?.data?.ticketData;
    try {
      if(res?.data?.status === 200){
        for(let i= 0; i <= ticketsdata.length; i++){
          // Counting completed tickets
          if(ticketsdata[i]?.STATUS === "Completed"){
            closedTicketCount += 1;
          }
          // Counting WIP tickets
          if(ticketsdata[i]?.STATUS === "WIP"){
            wipTicketCount += 1;
            setTicketAgeing5Days(isDateOlderThan5Days(ticketsdata[i].ISSUE_DATE))
          }
          if(ticketsdata[i]?.STATUS === "WIP" && ticketsdata[i]?.IS_IRATE_COMPLAINT === "1" && ticketsdata[i]?.FK_GROUP_ID === "2"){
            setDisplayIrateFlag(true); // setting irate flag true if condition match(ticket status:wip, IS_IRATE_COMPLAINT is 1, FK_GROUP_ID is 2)
          }
        }
        return {wipTicketCount, closedTicketCount}
      }
    } catch (error) {
      console.log(error)
    }
  }
 

  const employee_Details = async () =>{
    try {
      var result = await employeedetails(empid, ak)
      result = result.data
      if(result.status === "200"){
        const details = result.data
        setEmpDetails(details.employeeDetails)
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  const encodeObjectToBase64 = () => {
    if(empDetails.length > 0){
      let obj = {"ak":ak,"empid":empid,"glid":glid,"vertical_id":empDetails[0].VERTICALID,"VerticalName":empDetails[0].VERTICALNAME,"comp_name":companyname,"empGrade":"L1","func_area_name":empDetails[0].FUNCTIONALAREANAME,"department_name":empDetails[0].IIL_DEPT_NAME,"designation_name":empDetails[0].VERTICALNAME}
      const jsonString = JSON.stringify(obj);
      const base64 = btoa(unescape(encodeURIComponent(jsonString)));
      return base64;
    }
  }

  const activityChartLink = () =>{
    if(empDetails.length > 0){
      const decodeObject = {"ak":ak,"empid":empid,"glid":glid,"vertical_id":empDetails[0].VERTICALID,"VerticalName":empDetails[0].VERTICALNAME,"comp_name":companyname,"empGrade":"L1","func_area_name":empDetails[0].FUNCTIONALAREANAME,"department_name":empDetails[0].IIL_DEPT_NAME,"designation_name":empDetails[0].VERTICALNAME}
      const encodedString = encodeObjectToBase64(decodeObject);
      const link = `https://weberp.intermesh.net/r/ActivityChart/kyc?D=${encodedString}` // Redirecting customer insights to the KYC section instead of the Scorecard OP-562693.
      return link;
    }
  }

  useEffect(()=>{
    if(empid !== ''){
      employee_Details();;
      customerAtrributes(glid);
    }
  }, []);

  const Item = ({ leftTitle, leftValue, rightTitle, rightValue }) => {
    return (
      <div className="bg-bottom d-flex align-items-center">
        <div className="col-6">
          <div className="d-flex align-items-center" style={{height:'43px'}}>
            <div className="col-8">
              <h3>{leftTitle}</h3>
            </div>
            <div className="col-4">
              <span style={{'color':`${getColors(leftTitle, leftValue, '', paidFree)}` }}>{leftValue}</span>
            </div>
          </div>
        </div>
        <div className="col-6 ps-3 bg-left">
          <div className="d-flex align-items-center" style={{height:'43px'}}>
            <div className="col-9">
              <h3>{rightTitle}</h3>
            </div>
            <div className="col-3">
            {rightTitle === "Tickets WIP/Closed" ? 
              <><span style={{"color":`${getColors(rightTitle, rightValue, ticketAgeing5Days)}`}}>{ rightValue ? rightValue.split('/')[0] : 0}</span>/<span style={{'color':'black'}}>{rightValue ? rightValue.split('/')[1] : 0}</span></>
              : 
              <span style={{'color':`${getColors(rightTitle, rightValue, '', paidFree)}` }}>{rightValue}</span>
            }
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="col-4 h-100 ps-3">
      {(document.location.pathname === "/api/html" || document.location.pathname === "/Controllers/inBoundCenter.php") &&
        <ServiceDetails empid={empid} ak={ak} glid={glid} />
      }
      <div className="table-box">
        {data.map(item => (
          <Item
            key={item.id}
            leftTitle={item.leftTitle}
            leftValue={item.leftValue}
            rightTitle={item.rightTitle}
            rightValue={item.rightValue}
          />
        ))}
      </div>
      {
        pastServiceData.length > 0 ?
          <>
            <div className="df justify-between">
              {
                pastServiceData.length > 0 && <>
                  <div className="table-text cp" onClick={() => { handleShowPastServices() }}>
                    Past Services
                  </div>
                </>
              }
              {
                showPastServices && <PopupTable data={pastServiceData} marginTopClass="table-marginTop" />
              }
              <a href={activityChartLink()} target='new' className="table-text cp" onClick={() => {
                gaEvent(
                  "Customer Engagment New",
                  "Customer Engagment Details screen to view customer Details New",
                  "Customer Engagment Details screen to view customer Details New",
                  "Customer Engagment Details screen to view customer Details New",
                  glid
                )
              }}>
                Customer Insights
              </a>

            </div>
          </>
          :
          <a href={activityChartLink()} target='new' className="table-text cp" onClick={() => {
            gaEvent(
              "Customer Engagment New",
              "Customer Engagment Details screen to view customer Details New",
              "Customer Engagment Details screen to view customer Details New",
              "Customer Engagment Details screen to view customer Details New",
              glid
            )
          }}>
            Customer Insights
          </a>
      } 
    </div>
  );
};

export default CustomerEngagement;
